export default function(carbArr) {
  return {
    type: "SET_CARB_ARRAY",
    carbArr
  }
}



// WEBPACK FOOTER //
// ./src/actions/setMacrosMealArray/setCarbArr.js